import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {(key: string, opts?: any) => string} [deps.t]
 */
export function useDeleteVocab({
  callApiWithWorker,
  currentLang,
  pageIndex,
  pageSize,
  t,
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["deleteVocab"],
    mutationFn: async (fileHash) => {
      if (!fileHash) throw new Error("Missing vocabulary id");

      const res = await callApiWithWorker(
        `/api/vocabularyHub/delete/${encodeURIComponent(fileHash)}`,
        { method: "DELETE" },
      );

      const data = res?.data?.data ?? res?.data ?? res;
      const statusCode =
        res?.statusCode ??
        res?.data?.statusCode ??
        res?.status ??
        res?.data?.status;

      if (statusCode && statusCode >= 400) {
        const error = new Error(`Delete failed (${statusCode})`);
        error.statusCode = statusCode;
        error.response = data;
        throw error;
      }

      return data;
    },
    onSuccess: async () => {
      const queryKey =
        Number.isInteger(pageIndex) && Number.isInteger(pageSize)
          ? ["vocabsPaginated", currentLang, pageIndex, pageSize]
          : ["vocabsPaginated"];

      await queryClient.invalidateQueries({ queryKey });

      showSuccessToast(
        t?.("common.deleteSuccessMessage") || "Deleted successfully",
        {
          title: t?.("common.deleteSuccessTitle") || "Deleted!",
        },
      );
    },
    onError: async (error) => {
      showErrorAlert(error, t);
    },
  });
}
